<template>
 <div id="app">
  <div class="form__field">
   <div class="cell">
    <input @keyup.enter="queryResults" class="ids_topicSearch" id="ctl00_ids_contentPlaceHolder_ids_topicSearch" name="ctl00$ids_contentPlaceHolder$ids_topicSearch" placeholder="Search Contents" type="text" v-model="search"/>
   </div>
   <div class="search_button" v-if="search">
    <button @click="clearResult" class="close-icon">
     &times;
    </button>
   </div>
   <div class="search_button">
    <button @click="queryResults">
     <i class="fa fa-search">
     </i>
    </button>
   </div>
  </div>
  <div class="col-1 l-pad-top" id="results">
   <div>
    <p class="toc-2-style" style="margin-bottom: 10px;">
     <strong v-if="resultsCount != 0">
      ({{resultsCount}}) Results Found
     </strong>
     <strong v-else-if="resultsActual">
      No Results Found
     </strong>
    </p>
   </div>
   <div v-for="result of resultsActual">
    <p class="toc-2-style">
     <a :href="result.link" :keywords="result.keywords" onclick="reload(this.href, this.getAttribute('keywords'))">
      {{result.title}}
     </a>
    </p>
    <p class="toc-3-style">
     {{result.desc}}
    </p>
   </div>
  </div>
  <div class="side-toc" v-if="!resultsActual">
   <p class="toc-1-style">
    <a href="cover.html" title="Vi&scaron;efunkcijski uređaji CX331, CX431, MC3224, MC3326, MC3426, XC2326">
     Vi&scaron;efunkcijski uređaji CX331, CX431, MC3224, MC3326, MC3426, XC2326
    </a>
   </p>
   <p class="toc-1-style">
    <a href="safety.html#safety_hr" title="Sigurnosne informacije">
     Sigurnosne informacije
    </a>
   </p>
   <div id="divd0e18">
    <p class="toc-2-style">
     <a href=".html#d0e23" title="Pravila označavanja">
      Pravila označavanja
     </a>
    </p>
    <p class="toc-2-style">
     <a href="safety-cable-topic.html#d0e42" title="Izjave o proizvodu">
      Izjave o proizvodu
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="learning-about-printer-chapter.html#learning-about-printer-chapter_hr" title="Upoznavanje pisača">
     Upoznavanje pisača
    </a>
   </p>
   <div id="divd0e177">
    <p class="toc-2-style">
     <a href="finding-information-about-printer-topic.html#finding-information-about-printer_hr" title="Pronalaženje informacija o pisaču">
      Pronalaženje informacija o pisaču
     </a>
    </p>
    <p class="toc-2-style">
     <a href="finding-printer-serial-number-topic.html#finding-printer-serial-number_hr" title="Pronalaženje serijskog broja pisača">
      Pronalaženje serijskog broja pisača
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printer-configurations-topic.html#printer-configurations_hr" title="Konfiguracije pisača">
      Konfiguracije pisača
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-control-panel-topic.html#using-control-panel_hr" title="Upotreba upravljačke ploče">
      Upotreba upravljačke ploče
     </a>
    </p>
    <p class="toc-2-style">
     <a href="customizing-home-screen-topic.html#customizing-home-screen_hr" title="Prilagodba početnog zaslona">
      Prilagodba početnog zaslona
     </a>
    </p>
    <p class="toc-2-style">
     <a href="changing-language-of-keyboard-on-display-topic.html#changing-language-of-keyboard-on-display_hr" title="Promjena jezika tipkovnice na zaslonu">
      Promjena jezika tipkovnice na zaslonu
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-status-of-power-button-and-indicator-light-topic.html#understanding-status-of-power-button-and-indicator-light_hr" title="Razumijevanje statusa indikatora">
      Razumijevanje statusa indikatora
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-guidelines-topic.html#d0e600" title="Odabir papira">
      Odabir papira
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="setting-up-using-home-screen-apps-chapter.html#setting-up-using-home-screen-apps-chapter_hr" title="Postavljanje, instalacija i konfiguracija">
     Postavljanje, instalacija i konfiguracija
    </a>
   </p>
   <div id="divd0e1461">
    <p class="toc-2-style">
     <a href="selecting-location-printer-topic.html#selecting-location-printer_hr" title="Odabir lokacije za pisač">
      Odabir lokacije za pisač
     </a>
    </p>
    <p class="toc-2-style">
     <a href="attaching-cables-topic.html#attaching-cables_hr" title="Priključivanje kabela">
      Priključivanje kabela
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-optional-trays-topic.html#installing-optional-trays_hr" title="Postavljanje opcionalnih odlagača">
      Postavljanje opcionalnih odlagača
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-cloud-connector-profile-topic.html#d0e1674" title="Postavljanje i upotreba aplikacija na početnom zaslonu">
      Postavljanje i upotreba aplikacija na početnom zaslonu
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-printer-to-fax-group.html#d0e1799" title="Postavljanje pisača za faksiranje">
      Postavljanje pisača za faksiranje
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-smtp-server-for-e-mail-topic.html#configuring-smtp-server-for-e-mail_hr" title="Konfiguriranje postavki SMTP poslužitelja">
      Konfiguriranje postavki SMTP poslužitelja
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-paper-size-and-type-topic.html#d0e3819" title="Ulaganje papira i posebnih medija">
      Ulaganje papira i posebnih medija
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-printer-software-topic.html#d0e3988" title="Instaliranje i ažuriranje softvera, upravljačkih programa i programskih datoteka">
      Instaliranje i ažuriranje softvera, upravljačkih programa i programskih datoteka
     </a>
    </p>
    <p class="toc-2-style">
     <a href="available-options-topic.html#available-options_hr" title="Dostupne opcije">
      Dostupne opcije
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-wireless-front-solutions-module-topic.html#d0e4280" title="Umrežavanje">
      Umrežavanje
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-menu-settings-page-topic.html#printing-menu-settings-page_hr" title="Ispisivanje stranice s postavkama izbornika">
      Ispisivanje stranice s postavkama izbornika
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="securing-the-printer.html#securing-the-printer_hr" title="Osiguravanje pisača">
     Osiguravanje pisača
    </a>
   </p>
   <div id="divd0e4694">
    <p class="toc-2-style">
     <a href="erasing-printer-memory-topic.html#erasing-printer-memory_hr" title="Brisanje memorije pisača">
      Brisanje memorije pisača
     </a>
    </p>
    <p class="toc-2-style">
     <a href="restoring-factory-default-settings-topic.html#restoring-factory-default-settings_hr" title="Vraćanje tvornički zadanih postavki">
      Vraćanje tvornički zadanih postavki
     </a>
    </p>
    <p class="toc-2-style">
     <a href="statement-of-volatility-topic.html#statement-of-volatility_hr" title="Izjava o postojanosti memorije">
      Izjava o postojanosti memorije
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="printing-chapter.html#printing-chapter_hr" title="Ispisivanje">
     Ispisivanje
    </a>
   </p>
   <div id="divd0e4817">
    <p class="toc-2-style">
     <a href="printing-from-computer-h2-topic.html#printing-from-computer-h2_hr" title="Ispisivanje s računala">
      Ispisivanje s računala
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-mobile-device-using-lexmark-print-topic.html#d0e4843" title="Ispisivanje s mobilnog uređaja">
      Ispisivanje s mobilnog uređaja
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-flash-drive-topic.html#printing-from-flash-drive_hr" title="Ispisivanje s flash pogona">
      Ispisivanje s flash pogona
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-flash-drives-and-file-types-topic.html#supported-flash-drives-and-file-types_hr" title="Podržani flash pogoni i vrste datoteka">
      Podržani flash pogoni i vrste datoteka
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-confidential-jobs-topic.html#configuring-confidential-jobs_hr" title="Konfiguriranje povjerljivih zadataka">
      Konfiguriranje povjerljivih zadataka
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-confidential-and-other-held-jobs-topic.html#printing-confidential-and-other-held-jobs_hr" title="Ispisivanje povjerljivih i drugih zadržanih zadataka">
      Ispisivanje povjerljivih i drugih zadržanih zadataka
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-cloud-connector-profile-topic.html#printing-from-cloud-connector-profile_hr" title="Ispisivanje s Cloud Connector profila">
      Ispisivanje s Cloud Connector profila
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-font-sample-list-h2-topic.html#printing-font-sample-list-h2_hr" title="Ispisivanje popisa uzoraka fontova">
      Ispisivanje popisa uzoraka fontova
     </a>
    </p>
    <p class="toc-2-style">
     <a href="placing-separator-sheets-topic.html#placing-separator-sheets_hr" title="Postavljanje razdjelnih stranica između kopija">
      Postavljanje razdjelnih stranica između kopija
     </a>
    </p>
    <p class="toc-2-style">
     <a href="canceling-print-job-topic.html#canceling-print-job_hr" title="Otkazivanje zadatka ispisivanja">
      Otkazivanje zadatka ispisivanja
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-toner-darkness-topic.html#adjusting-toner-darkness_hr" title="Prilagođavanje zatamnjenosti tonera">
      Prilagođavanje zatamnjenosti tonera
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="copying.html#copying_hr" title="Kopiranje">
     Kopiranje
    </a>
   </p>
   <div id="divd0e5458">
    <p class="toc-2-style">
     <a href="using-ADF-and-scanner-glass-copy-topic.html#using-ADF-and-scanner-glass-copy_hr" title="Upotreba automatskog ulagača dokumenata i stakla skenera">
      Upotreba automatskog ulagača dokumenata i stakla skenera
     </a>
    </p>
    <p class="toc-2-style">
     <a href="making-copies-topic.html#making-copies_hr" title="Izrada kopija">
      Izrada kopija
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-photos-topic.html#copying-photos_hr" title="Kopiranje fotografija">
      Kopiranje fotografija
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-transparencies-or-letterhead-topic.html#copying-transparencies-or-letterhead_hr" title="Kopiranje na papir sa zaglavljem">
      Kopiranje na papir sa zaglavljem
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-on-both-sides-of-paper-topic.html#copying-on-both-sides-of-paper_hr" title="Kopiranje na obje strane papira">
      Kopiranje na obje strane papira
     </a>
    </p>
    <p class="toc-2-style">
     <a href="reducing-enlarging-copies-topic.html#reducing-enlarging-copies_hr" title="Smanjenje ili povećanje kopija">
      Smanjenje ili povećanje kopija
     </a>
    </p>
    <p class="toc-2-style">
     <a href="saving-paper-topic.html#saving-paper_hr" title="Kopiranje vi&scaron;e stranica na samo jedan list">
      Kopiranje vi&scaron;e stranica na samo jedan list
     </a>
    </p>
    <p class="toc-2-style">
     <a href="collating-copies-topic.html#collating-copies_hr" title="Razvrstavanje kopija">
      Razvrstavanje kopija
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-cards-topic.html#copying-cards_hr" title="Kopiranje kartica">
      Kopiranje kartica
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-copy-shortcut-topic.html#creating-copy-shortcut_hr" title="Stvaranje prečaca za kopiranje">
      Stvaranje prečaca za kopiranje
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="E-mailing.html#E-mailing_hr" title="E-po&scaron;ta">
     E-po&scaron;ta
    </a>
   </p>
   <div id="divd0e5744">
    <p class="toc-2-style">
     <a href="using-ADF-and-scanner-glass-e-mail-topic.html#using-ADF-and-scanner-glass-e-mail_hr" title="Upotreba automatskog ulagača dokumenata i stakla skenera">
      Upotreba automatskog ulagača dokumenata i stakla skenera
     </a>
    </p>
    <p class="toc-2-style">
     <a href="sending-email-topic.html#sending-email_hr" title="Slanje e-po&scaron;te">
      Slanje e-po&scaron;te
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-email-shortcut-topic.html#creating-email-shortcut-using-control-panel_hr" title="Stvaranje prečaca za e-po&scaron;tu">
      Stvaranje prečaca za e-po&scaron;tu
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="Faxing.html#Faxing_hr" title="Faks">
     Faks
    </a>
   </p>
   <div id="divd0e5862">
    <p class="toc-2-style">
     <a href="using-ADF-and-scanner-glass-fax-topic.html#using-ADF-and-scanner-glass-fax_hr" title="Upotreba automatskog ulagača dokumenata i stakla skenera">
      Upotreba automatskog ulagača dokumenata i stakla skenera
     </a>
    </p>
    <p class="toc-2-style">
     <a href="sending-fax-topic.html#sending-fax_hr" title="Slanje faksa">
      Slanje faksa
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scheduling-fax-topic.html#scheduling-fax_hr" title="Zakazivanje faksa">
      Zakazivanje faksa
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-fax-destination-shortcut-topic.html#creating-fax-destination-shortcut_hr" title="Stvaranje prečaca za odredi&scaron;ni faks">
      Stvaranje prečaca za odredi&scaron;ni faks
     </a>
    </p>
    <p class="toc-2-style">
     <a href="changing-fax-resolution-topic.html#changing-fax-resolution_hr" title="Promjena razlučivosti faksa">
      Promjena razlučivosti faksa
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-fax-darkness-topic.html#adjusting-fax-darkness_hr" title="Pode&scaron;avanje zatamnjenja faksa">
      Pode&scaron;avanje zatamnjenja faksa
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-fax-log-topic.html#printing-fax-log_hr" title="Ispis zapisnika faksiranja">
      Ispis zapisnika faksiranja
     </a>
    </p>
    <p class="toc-2-style">
     <a href="blocking-junk-faxes-topic.html#blocking-junk-faxes_hr" title="Blokiranje neželjenih faksova">
      Blokiranje neželjenih faksova
     </a>
    </p>
    <p class="toc-2-style">
     <a href="holding-faxes-topic.html#holding-faxes_hr" title="Stavljanje faksova na čekanje">
      Stavljanje faksova na čekanje
     </a>
    </p>
    <p class="toc-2-style">
     <a href="forwarding-fax-topic.html#forwarding-fax_hr" title="Prosljeđivanje faksa">
      Prosljeđivanje faksa
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="FTP.html#FTP_hr" title="Skeniranje">
     Skeniranje
    </a>
   </p>
   <div id="divd0e6242">
    <p class="toc-2-style">
     <a href="using-ADF-and-scanner-glass-scan-topic.html#using-ADF-and-scanner-glass-scan_hr" title="Upotreba automatskog ulagača dokumenata i stakla skenera">
      Upotreba automatskog ulagača dokumenata i stakla skenera
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scanning-to-computer-topic.html#scanning-to-computer_hr" title="Skeniranje na računalo">
      Skeniranje na računalo
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scanning-to-ftp-server-using-shortcut-topic.html#scanning-to-ftp-server-using-shortcut_hr" title="Skeniranje na FTP poslužitelj s pomoću prečaca">
      Skeniranje na FTP poslužitelj s pomoću prečaca
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scanning-network-folder-using-shortcut-topic.html#scanning-network-folder-using-shortcut_hr" title="Skeniranje u mrežnu mapu pomoću prečaca">
      Skeniranje u mrežnu mapu pomoću prečaca
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scanning-to-flash-drive-topic.html#scanning-to-flash-drive_hr" title="Skeniranje na flash pogon">
      Skeniranje na flash pogon
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scanning-to-cloud-connector-profile-topic.html#scanning-to-cloud-connector-profile_hr" title="Skeniranje u Cloud Connector profil">
      Skeniranje u Cloud Connector profil
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="understanding-printer-menus-chapter.html#understanding-printer-menus-chapter_hr" title="Upotreba izbornika pisača">
     Upotreba izbornika pisača
    </a>
   </p>
   <div id="divd0e6576">
    <p class="toc-2-style">
     <a href="menu-map-mfp-topic.html#menus-map-mfp_hr" title="Karta izbornika">
      Karta izbornika
     </a>
    </p>
    <p class="toc-2-style">
     <a href="preferences-topic.html#d0e6906" title="Uređaj">
      Uređaj
     </a>
    </p>
    <p class="toc-2-style">
     <a href="layout-topic.html#d0e8911" title="Ispisivanje">
      Ispisivanje
     </a>
    </p>
    <p class="toc-2-style">
     <a href="tray-configuration-topic.html#d0e9825" title="Papir">
      Papir
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copy-defaults-topic.html#d0e10138" title="Kopiranje">
      Kopiranje
     </a>
    </p>
    <p class="toc-2-style">
     <a href="fax-defaults-subgroup.html#d0e10470" title="Faks">
      Faks
     </a>
    </p>
    <p class="toc-2-style">
     <a href="email-setup-topic.html#d0e12088" title="E-po&scaron;ta">
      E-po&scaron;ta
     </a>
    </p>
    <p class="toc-2-style">
     <a href="ftp-defaults-topic.html#d0e12771" title="FTP">
      FTP
     </a>
    </p>
    <p class="toc-2-style">
     <a href="flash-drive-scan-topic.html#d0e13203" title="USB pogon">
      USB pogon
     </a>
    </p>
    <p class="toc-2-style">
     <a href="network-overview-topic.html#d0e13822" title="Mreža/priključci">
      Mreža/priključci
     </a>
    </p>
    <p class="toc-2-style">
     <a href="login-methods-subgroup.html#d0e15818" title="Sigurnost">
      Sigurnost
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cloud-connector-menu-topic.html#cloud-connector-menu_hr" title="Cloud Connector">
      Cloud Connector
     </a>
    </p>
    <p class="toc-2-style">
     <a href="menu-settings-page-topic.html#d0e16547" title="Izvje&scaron;ća">
      Izvje&scaron;ća
     </a>
    </p>
    <p class="toc-2-style">
     <a href="troubleshooting-menu-topic.html#troubleshooting-menu_hr" title="Rje&scaron;avanje problema">
      Rje&scaron;avanje problema
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="maintain-printer-chapter.html#maintain-printer-chapter_hr" title="Održavanje pisača">
     Održavanje pisača
    </a>
   </p>
   <div id="divd0e16855">
    <p class="toc-2-style">
     <a href="checking-status-of-parts-and-supplies-topic.html#checking-status-of-parts-and-supplies_hr" title="Provjera statusa dijelova i potro&scaron;nog materijala">
      Provjera statusa dijelova i potro&scaron;nog materijala
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-supply-notifications-topic.html#configuring-supply-notifications_hr" title="Konfiguriranje obavijesti o potro&scaron;nom materijalu">
      Konfiguriranje obavijesti o potro&scaron;nom materijalu
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-e-mail-alert-topic.html#setting-up-e-mail-alert_hr" title="Postavljanje upozorenja za e-po&scaron;tu">
      Postavljanje upozorenja za e-po&scaron;tu
     </a>
    </p>
    <p class="toc-2-style">
     <a href="viewing-reports-topic.html#viewing-reports_hr" title="Pregledavanje izvje&scaron;ća">
      Pregledavanje izvje&scaron;ća
     </a>
    </p>
    <p class="toc-2-style">
     <a href="ordering-supplies-group.html#ordering-supplies-group_hr" title="Naručivanje dijelova i potro&scaron;nog materijala">
      Naručivanje dijelova i potro&scaron;nog materijala
     </a>
    </p>
    <p class="toc-2-style">
     <a href="replacing-print-cartridge-topic.html#d0e17633" title="Zamjena dijelova i potro&scaron;nog materijala">
      Zamjena dijelova i potro&scaron;nog materijala
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cleaning-printer-topic.html#d0e17882" title="Či&scaron;ćenje dijelova pisača">
      Či&scaron;ćenje dijelova pisača
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-power-save-mode-settings-topic.html#d0e18036" title="&Scaron;tednja energije i papira">
      &Scaron;tednja energije i papira
     </a>
    </p>
    <p class="toc-2-style">
     <a href="moving-printer-topic.html#moving-printer_hr" title="Premje&scaron;tanje pisača na drugu lokaciju">
      Premje&scaron;tanje pisača na drugu lokaciju
     </a>
    </p>
    <p class="toc-2-style">
     <a href="shipping-printer-topic.html#shipping-printer_hr" title="Otprema pisača">
      Otprema pisača
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="troubleshooting-chapter.html#troubleshooting-chapter_hr" title="Rje&scaron;avanje problema">
     Rje&scaron;avanje problema
    </a>
   </p>
   <div id="divd0e18193">
    <p class="toc-2-style">
     <a href="print-quality-problems-topic.html#print-quality-problems_hr" title="Problemi s kvalitetom ispisa">
      Problemi s kvalitetom ispisa
     </a>
    </p>
    <p class="toc-2-style">
     <a href="solving-printing-problems.html#solving-printing-problems_hr" title="Problemi s ispisivanjem">
      Problemi s ispisivanjem
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-printer-not-responding-topic.html#trb-printer-not-responding_hr" title="Pisač ne reagira">
      Pisač ne reagira
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-unable-to-read-flash-drive-topic.html#trb-unable-to-read-flash-drive_hr" title="Flash pogon ne može se očitati">
      Flash pogon ne može se očitati
     </a>
    </p>
    <p class="toc-2-style">
     <a href="enabling-usb-port-topic.html#enabling-usb-port_hr" title="Omogućavanje USB priključka">
      Omogućavanje USB priključka
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-open-embedded-web-server-topic.html#d0e20762" title="Problemi s mrežnom vezom">
      Problemi s mrežnom vezom
     </a>
    </p>
    <p class="toc-2-style">
     <a href="message-replace-cartridge-printer-region-mismatch-topic.html#d0e20974" title="Problemi s potro&scaron;nim materijalom">
      Problemi s potro&scaron;nim materijalom
     </a>
    </p>
    <p class="toc-2-style">
     <a href="clearing-jams.html#clearing-jams_hr" title="Otklanjanje zaglavljenih papira">
      Otklanjanje zaglavljenih papira
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-envelope-seals-when-printing-topic.html#d0e21449" title="Problemi s ulaganjem papira">
      Problemi s ulaganjem papira
     </a>
    </p>
    <p class="toc-2-style">
     <a href="disabling-smtp-server-not-setup-error-topic.html#d0e21816" title="Problemi s e-po&scaron;tom">
      Problemi s e-po&scaron;tom
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-caller-id-not-shown-topic.html#d0e21912" title="Problemi s faksiranjem">
      Problemi s faksiranjem
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-scan-to-computer-topic.html#d0e22550" title="Problemi sa skeniranjem">
      Problemi sa skeniranjem
     </a>
    </p>
    <p class="toc-2-style">
     <a href="modifying-colors-in-printed-output-topic.html#d0e23328" title="Problemi s kvalitetom boje">
      Problemi s kvalitetom boje
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-contacting-customer-support-topic.html#trb-contacting-customer-support_hr" title="Obraćanje službi za korisničku podr&scaron;ku">
      Obraćanje službi za korisničku podr&scaron;ku
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="recycle-dispose-chapter.html#recycle-dispose-chapter_hr" title="Recikliranje i odlaganje">
     Recikliranje i odlaganje
    </a>
   </p>
   <div id="divd0e23578">
    <p class="toc-2-style">
     <a href="recycling-lexmark-products-topic.html#recycling-lexmark-products_hr" title="Recikliranje Lexmark proizvoda">
      Recikliranje Lexmark proizvoda
     </a>
    </p>
    <p class="toc-2-style">
     <a href="recycling-lexmark-packaging-topic.html#recycling-lexmark-packaging_hr" title="Recikliranje pakiranja Lexmark proizvoda">
      Recikliranje pakiranja Lexmark proizvoda
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="laser_ug_notices.html#laser_ug_notices_hr" title="Obavijesti">
     Obavijesti
    </a>
   </p>
   <div id="divd0e23613">
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e23616" title="Informacije o proizvodu">
      Informacije o proizvodu
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e23633" title="Obavijest o izdanju">
      Obavijest o izdanju
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#trademarks_hr" title="Za&scaron;titni znakovi">
      Za&scaron;titni znakovi
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#licensing-notices_hr" title="Napomene o licenciranju">
      Napomene o licenciranju
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#noise-emission-levels_hr" title="Razine emisije buke">
      Razine emisije buke
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#weee-directive_hr" title="Direktiva Otpadna električna i elektronička oprema (WEEE)">
      Direktiva Otpadna električna i elektronička oprema (WEEE)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e23742" title="Environmental labeling for packaging">
      Environmental labeling for packaging
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#product-disposal_hr" title="Odlaganje proizvoda">
      Odlaganje proizvoda
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e23776" title="Litij-ionska punjiva baterija">
      Litij-ionska punjiva baterija
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#eu-battery-directive-2023-1542_hr" title="Uredba (EU) 2023/1542">
      Uredba (EU) 2023/1542
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#returning-lexmark-cartridges-for-reuse-or-recycling_hr" title="Vraćanje Lexmarkovih spremnika za ponovnu upotrebu i recikliranje">
      Vraćanje Lexmarkovih spremnika za ponovnu upotrebu i recikliranje
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#returning-lexmark-cartridges-for-reuse-or-recycling_hr" title="Vraćanje Lexmarkovih spremnika za ponovnu upotrebu i recikliranje">
      Vraćanje Lexmarkovih spremnika za ponovnu upotrebu i recikliranje
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#static-sensitivity-notice_hr" title="Obavijest o osjetljivosti na statički elektricitet">
      Obavijest o osjetljivosti na statički elektricitet
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#energy-star_hr" title="ENERGY STAR">
      ENERGY STAR
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#temperature-information_hr" title="Informacije o temperaturi">
      Informacije o temperaturi
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#laser-notice_hr" title="Obavijest o laseru">
      Obavijest o laseru
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#power-consumption_hr" title="Potro&scaron;nja energije">
      Potro&scaron;nja energije
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#regulatory-notices-for-telecommunication-terminal-equipment_hr" title="Regulatorne napomene za telekomunikacijsku terminalnu opremu">
      Regulatorne napomene za telekomunikacijsku terminalnu opremu
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e24057" title="Regulatorne napomene za bežične proizvode">
      Regulatorne napomene za bežične proizvode
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#modular-component-notice_hr" title="Obavijest o modularnoj komponenti">
      Obavijest o modularnoj komponenti
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#exposure-to-radio-frequency-radiation_hr" title="Izloženost zračenju radijskih frekvencija">
      Izloženost zračenju radijskih frekvencija
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e24083" title="Sukladnost direktivama Europske zajednice (EZ)">
      Sukladnost direktivama Europske zajednice (EZ)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#european-community-ec-directives-conformity-class-b_hr" title="Sukladnost direktivama Europske zajednice (EZ)">
      Sukladnost direktivama Europske zajednice (EZ)
     </a>
    </p>
   </div>
  </div>
 </div>
</template>
<script>
 import output from './output.json';

const fuzzysort = require('fuzzysort');
const lunr = require("lunr")
require("lunr-languages/lunr.stemmer.support.js")(lunr)
require('lunr-languages/lunr.multi')(lunr)
require("lunr-languages/tinyseg.js")(lunr)
require("lunr-languages/lunr.de.js")(lunr)
require("lunr-languages/lunr.es.js")(lunr)
require("lunr-languages/lunr.fr.js")(lunr)
require("lunr-languages/lunr.it.js")(lunr)
require("lunr-languages/lunr.ja.js")(lunr)
require("lunr-languages/lunr.pt.js")(lunr)

export default {
  name: 'app',
  data() {
    return {
        search: '',
        resultsActual: '',
        list: output,
        resultsCount: 0,
    }
  },

  methods: { queryResults() {

      if (this.search.trim() === ''){
        return  '';
      }
    //   else if(this.search.trim().length < 3){
    //     this.resultsActual = new Array();
    //     this.resultsCount = 0;
    //   }
      else {
        var documents = this.list;

        var idx = lunr(function () {
            this.use(lunr.ja);
            this.use(lunr.multiLanguage('en', 'de', 'es', 'fr', 'it', 'ja', 'pt'))
            this.ref('UUID');
            this.field('title');
            this.field('descFull');
            this.metadataWhitelist = ['position'];

            documents.forEach(function (doc) {
                        this.add(doc)
                    },this);
            });
        

        var searchTerms = this.search.replace(/[`~!#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\/]/gi, ' ').trim().replace(/\s\s+/g, " ");
        // var searchTerms = this.search;
        searchTerms = this.removeStopWords(searchTerms);
        var searchRawTerms = searchTerms;
        // searchTerms  =  searchTerms.split(" ").join(" +");
        // searchTerms = searchTerms.startsWith(" +") ? searchTerms : "+" + searchTerms;

        console.log(searchTerms);
        var results = idx.search(searchTerms);

        console.log (results);

        results = results.map(res => {
            var linkRes =  documents.find(elem => elem.UUID == res.ref);
            var keywords_array = new Array();
            var keywords_arrays = new Array();
            var keywords_arrays_title = new Array();

            Object.keys(res.matchData.metadata).map(kys => {
                var positions_title = res.matchData.metadata[kys].title;
                var positions_desc = res.matchData.metadata[kys].descFull;

                if(typeof positions_title !== 'undefined' ){
                    positions_title.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays_title.push(val[0],val[1]);
                    });
                }

                if(typeof positions_desc !== 'undefined' ){
                    positions_desc.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays.push(val[0],val[1]);
                    });
                }
            });

            

            res.link = linkRes.link;
            res.desc = linkRes.desc;
            res.title = linkRes.title;
            res.full = linkRes.descFull;
            res.titleArray = keywords_arrays_title;
            res.descArray = keywords_arrays;
            keywords_array = keywords_array.filter(function(item, index){ 
                return searchRawTerms.indexOf(item) >= 0;
            });
            var keywords_set = new Set(keywords_array);
            res.keywords = [...keywords_set].toString();
            // res.keywords = ["ramon","joe","gudz"]
            return res;
        });
        
        var existingPagesInResult = new Array();
        

       
        results = results.filter(function(item, index){
                
            if(existingPagesInResult.includes(item.link)){
                
                return false;
            }
            else { 
                existingPagesInResult.push(item.link);
                return true;
            }

            if(res.keywords == ""){
                return false;
            }
        });

        

        console.log (results);
        this.resultsActual = results;
        this.resultsCount = results.length;
      }
    },

    clearResult: function(){
        this.search = "";
        this.resultsActual = undefined;
        this.resultsCount = 0;
        reload("cover.html", "");
       
    },  

    removeStopWords: function(queryString) {
        const stopWords = ['i', 'me', 'my', 'myself', 'we', 'our', 'ours', 'ourselves', 'you', "you're", "you've", "you'll", "you'd", 'your', 'yours', 'yourself', 'yourselves', 
        'he', 'him', 'his', 'himself', 'she', "she's", 'her', 'hers', 'herself', 'it', "it's", 'its', 'itself', 'they', 'them', 'their', 'theirs', 'themselves', 'what', 'which', 
        'who', 'whom', 'this', 'that', "that'll", 'these', 'those', 'am', 'is', 'are', 'was', 'were', 'be', 'been', 'being', 'have', 'has', 'had', 'having', 'do', 'does', 'did', 
        'doing', 'a', 'an', 'the', 'and', 'but', 'if', 'or', 'because', 'as', 'until', 'while', 'of', 'at', 'by', 'for', 'with', 'about', 'against', 'between', 'into', 'through', 
        'during', 'before', 'after', 'above', 'below', 'to', 'from', 'up', 'down', 'in', 'out', 'on', 'off', 'over', 'under', 'again', 'further', 'then', 'once', 'here', 'there', 
        'when', 'where', 'why', 'how', 'all', 'any', 'both', 'each', 'few', 'more', 'most', 'other', 'some', 'such', 'no', 'nor', 'not', 'only', 'own', 'same', 'so', 'than', 'too', 
        'very', 's', 't', 'can', 'will', 'just', 'don', "don't", 'should', "should've", 'now', 'd', 'll', 'm', 'o', 're', 've', 'y', 'ain', 'aren', "aren't", 'couldn', "couldn't", 
        'didn', "didn't", 'doesn', "doesn't", 'hadn', "hadn't", 'hasn', "hasn't", 'haven', "haven't", 'isn', "isn't", 'ma', 'mightn', "mightn't", 'mustn', "mustn't", 'needn', 
         "needn't", 'shan', "shan't", 'shouldn', "shouldn't", 'wasn', "wasn't", 'weren', "weren't", 'won', "won't", 'wouldn', "wouldn't"]

        var cleanQueryString = new Array();
        queryString.split(" ").forEach(word => {
             if(!stopWords.includes(word)) {
                 cleanQueryString.push(word);
             }
        });

        return cleanQueryString.join(" ");
    },
    
  }
}
</script>


// WEBPACK FOOTER //
// src/App.vue